import React, { useState, useRef, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import GaugeChart from 'react-gauge-chart'
import useInterval from '@use-it/interval'
import clap from 'video_room/gauge/gauge_hands.svg'

import 'velocity-animate'
import 'velocity-animate/velocity.ui'
import {VelocityComponent, VelocityTransitionGroup, velocityHelpers } from 'velocity-react';


const PulseClapAnimation = velocityHelpers.registerEffect("callout.pulseClap", {
  defaultDuration: 150,
  calls: [
    [ { scale: 1.4 }, 0.50, { ease: "easeOutBack"} ],
    [ { scale: 1 }, 0.50, { ease: "easeOutBack"} ]
  ]
})

export default function Gauge({defaultGaugeValue, props}) {
  let [percent, setPercent] = useState(0.0)
  let [showAnimation, setShowAnimation] = useState(false)
  const gaugeValue = useSelector(state => state.gaugeValue) || defaultGaugeValue || 0.0

  useInterval(() => {
    let val = gaugeValue + ((Math.random() / 10) / 4) + (showAnimation ? 0.05 : 0)
    setPercent(val)
  }, 1100)

  return <>
    <VelocityComponent interruptBehavior={"queue"} animation={{opacity: gaugeValue > 0 ? 1 : 0}}>
      <div className="gauge-row row d-flex noselect">
        <div className="col align-self-center">
          <GaugeChart id="gauge-chart3"
                      nrOfLevels={34}
                      animDelay={0}
                      animateDuration={50}
                      colors={["#FFFFFF"]}
                      arcWidth={0.3}
                      cornerRadius={0}
                      animate={true}
                      needleColor={"#FFFFFF"}
                      needleBaseColor={"#FFFFFF"}
                      percent={percent}
          />
        </div>
        <div className="col align-self-center" style={{color: "white", pointerEvents: "all"}}>
          <VelocityComponent interruptBehavior={"queue"} animation={showAnimation ? PulseClapAnimation : null}>
            <img className="pointer" style={{pointerEvents: "all"}} src={clap} onClick={() => {
              if(!showAnimation)
                setShowAnimation(true)

              setTimeout(function() {
                setShowAnimation(false)
              }, 150)
            }}
                 style={{maxWidth: "40%"}}/>
          </VelocityComponent>
        </div>
      </div>
    </VelocityComponent>
  </>
}